/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * master table for all selectable or link-accessible analytic/data retrievals, corresponds to an analysis model.
 */
export interface AnalyticProcess { 
    /**
     * Internal AnalyticProcess Key
     */
    id: number;
    name: string;
    type: string;
    useCase?: string;
    legendeText?: string;
    isVisibleDashboard?: boolean;
    sourceType?: string;
    procName?: string;
    /**
     * ID of the process-group of which this analyticprocess is a member
     */
    analyticProcessGroupId?: number;
    /**
     * configuration of Interaction/filter options for the displayed map
     */
    filterOptions?: Array<{ [key: string]: string; }>;
    /**
     * configuration of map markers options for the displayed map
     */
    markerOptions?: { [key: string]: string; };
}

